<template>
  <div>
    <div class="vx-row" v-can:any="['view-order', 'edit-order']">
      <div class="vx-col w-full">
        <vx-card title="RM ORDERS" >
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="15%" sort-key="created_at">DATE/TIME</vs-th>
                <vs-th width="10%" sort-key="product_order_code">ORDER CODE</vs-th>
                <vs-th width="15%" >SUPPLIER</vs-th>
                <vs-th width="15%">ORDER BY</vs-th>
                <vs-th width="20%" >ITEMS</vs-th>
                <vs-th width="15%" >STATUS</vs-th>
                <vs-th width="10%" class="">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickOrderDetails(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td class="text-primary font-bold" :data="data[indextr].purchase_order_code">
                    {{ data[indextr].purchase_order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    {{ data[indextr].supplier}}
                  </vs-td>

                  <vs-td :data="data[indextr].staff">
                    {{ data[indextr].staff}}
                  </vs-td>


                  <vs-td :data="data[indextr].raw_material_items">
                    <span v-if="data[indextr].raw_material_items.length > 0" v-for="(item, index_item) in data[indextr].raw_material_items" :key="item.id">
                      <a v-on:click.prevent="onClickFinishedProduct(item.id)">{{ item.supplier_product_code }}</a>
                      <span v-if="data[indextr].raw_material_items.length !== index_item+1"> , </span>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0" class="text-center" transparent :color="data[indextr].is_item_status_handled_individually ? 'dark' : ProductOrderStatusColorFactory(tr.status.name)">
                      {{ data[indextr].is_item_status_handled_individually ? 'PO Ungrouped' : data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" text="View Order" position="left">
                        <vs-button @click.stop="onClickOrderDetails(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Pages"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"
              class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const TradingRepository = RepositoryFactory.get('trading')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import ProductOrderTable from './ProductOrderTable'
  import {defaultPagination, perPageList} from "../../../../constants/config";
  import {raw_material_order_statuses} from '@/constants/statuses'


  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        is_on_create: false,
        perPage: defaultPagination,
        descriptionItems: perPageList,
        raw_material_order_statuses: raw_material_order_statuses
      }
    },
    components: {
      'v-select': vSelect,
      ProductOrderTable
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async getProductOrderList() {
        this.$vs.loading()
        const {data} = await TradingRepository.getListRmOrders(this.page, this.filterQuery, this.perPage)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },
      filterQueryUpdate (){
        this.getProductOrderList()
      },

      handleChangePage(page) {
        this.page=page;
        this.getProductOrderList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.getProductOrderList()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      ProductOrderStatusColorFactory(status_name) {
        let selected_status = this.raw_material_order_statuses.find((n) => n.name === status_name)
        return selected_status ?  selected_status.color : 'warning'
      },
      onClickFinishedProduct(id) {
        this.$router.push({path: `/pages/raw-materials/${id}`})
      },
      onClickOrderDetails(id) {
        this.$router.push({path: `/pages/trading-summary/rm-orders/${id}`})
      },
    },
    watch : {
      page(){
        this.getProductOrderList()
      },
      perPage() {
        this.getProductOrderList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
